var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-loading",class:[{ 't-loading--centered': _vm.centered }]},[_c(_vm.image,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }